import { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react'

const ReducedMotionContext = createContext(null)

const REDUCED_MOTION_KEY = 'verse-reduced-motion'

export function ReducedMotionProvider({ children }) {
  const [reducedMotion, setReducedMotionState] = useState(() => {
    const saved = localStorage.getItem(REDUCED_MOTION_KEY)
    if (saved != null) return saved === 'true'
    return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-reduced-motion', reducedMotion ? 'reduce' : 'no-preference')
    localStorage.setItem(REDUCED_MOTION_KEY, reducedMotion ? 'true' : 'false')
  }, [reducedMotion])

  const setReducedMotion = useCallback((value) => {
    setReducedMotionState(value)
  }, [])

  const value = useMemo(() => ({
    reducedMotion, setReducedMotion
  }), [reducedMotion, setReducedMotion])

  return (
    <ReducedMotionContext.Provider value={value}>
      {children}
    </ReducedMotionContext.Provider>
  )
}

export function useReducedMotion() {
  return useContext(ReducedMotionContext)
}